import { Button, styled } from "@mui/material";

interface BotaoCustomizadoProps {
    cor?: string,
    corDeFundo?: string,
    modelo?: 'primario' | 'secundario' | 'outros',
    altura?: string,
    largura?: string
}

export const BotaoCustomizado = styled(Button)<BotaoCustomizadoProps>(({ cor, corDeFundo, modelo, altura, largura }) => ({
    borderRadius: '8px',
    boxShadow: 'none',
    width: largura !== undefined ? largura : '100%',
    height: altura !== undefined ? altura : '3.5rem',
    ...(modelo === 'primario' && {
        backgroundColor: '#E9775F',
        color: 'white',
        '&:hover': {
            backgroundColor: 'white',
            color: '#E9775F',
            border: '1px solid #E9775F',
            boxShadow: 'none',
        }
    }),
    ...(modelo === 'secundario' && {
        color: '#E9775F',
        backgroundColor: 'white',
        border: '1px solid #E9775F',
    }),
}));